// @ts-nocheck


import { classesRuntime, statesRuntime } from "../../stylable-esm-runtime.js";



var _namespace_ = "NestedTableRow1421058637";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st: import("@stylable/runtime").STFunction = _style_;

export var namespace = _namespace_;
export var classes = {"root":"NestedTableRow1421058637__root","firstLevel":"NestedTableRow1421058637__firstLevel","placeholder":"NestedTableRow1421058637__placeholder","parentHovered":"NestedTableRow1421058637__parentHovered"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




